const DB_NAME = 'studio_cache_db';
const DB_VERSION = 1;
const STORE_NAME = 'projects';

const openDb = () =>
  new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onerror = () => reject(request.error);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'projectId' });
      }
    };
    request.onsuccess = () => resolve(request.result);
  });

const withStore = async (mode, callback) => {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, mode);
    const store = tx.objectStore(STORE_NAME);
    let result;
    try {
      result = callback(store);
    } catch (error) {
      reject(error);
      return;
    }
    tx.oncomplete = () => resolve(result);
    tx.onerror = () => reject(tx.error);
    tx.onabort = () => reject(tx.error);
  }).finally(() => {
    db.close();
  });
};

export const readProjectCache = async (projectId) => {
  if (!projectId) return null;
  return withStore('readonly', (store) => store.get(projectId));
};

export const writeProjectCache = async (projectId, payload) => {
  if (!projectId || !payload) return;
  const record = {
    projectId,
    updatedAt: new Date().toISOString(),
    data: payload,
  };
  return withStore('readwrite', (store) => store.put(record));
};

export const clearProjectCache = async (projectId) => {
  if (!projectId) return;
  return withStore('readwrite', (store) => store.delete(projectId));
};
